import React from 'react';

import { CircularProgress, IconButton, InputAdornment, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const CustomFindField = ({
  field,
  form,
  loading,
  onClickButton,
  readOnly = true,
  disabled = false,
  ...other
}) => {
  const handleClickButton = () => {
    if (onClickButton) {
      onClickButton();
    }
  };

  const LoadingAdornment = () => {
    return (
      <InputAdornment position="end">
        <CircularProgress size={16} />
      </InputAdornment>
    );
  };

  const SearchAdornment = () => {
    return (
      <InputAdornment position="end">
        <IconButton disabled={disabled} onClick={handleClickButton}>
          <SearchIcon />
        </IconButton>
      </InputAdornment>
    );
  };

  return (
    <TextField
      variant="filled"
      fullWidth
      InputLabelProps={{ shrink: true }}
      name={field.name}
      {...field}
      disabled={disabled}
      error={Boolean(form.errors[field.name]) && form.touched[field.name]}
      helperText={form.touched[field.name] && form.errors[field.name]}
      InputProps={
        loading
          ? {
              endAdornment: <LoadingAdornment />,
            }
          : {
              endAdornment: <SearchAdornment />,
            }
      }
      inputProps={{
        readOnly: readOnly,
      }}
      {...other}
    />
  );
};

export default CustomFindField;
